import * as React from 'react';
import { useCallback } from 'react';
import {ExportButton, FilterButton, List, TopToolbar} from 'react-admin';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import { Box, Drawer, useMediaQuery, Theme } from '@mui/material';
import HitchRequestsListMobile from './HitchRequestsListMobile';
import HitchRequestsListDesktop from './HitchRequestsListDesktop';
import hitchRequestsFilters from './hitchRequestsFilters';
import HitchRequestShow from './HitchRequestShow';

const HitchRequestsList = () => {
    const isXSmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );
    const location = useLocation();
    const navigate = useNavigate();

    const handleClose = useCallback(() => {
        navigate('/hitch-requests');
    }, [navigate]);

    const match = matchPath('/hitch-requests/:id', location.pathname);

    const filters: JSX.Element[] = hitchRequestsFilters();

    return (
        <Box display="flex">
            <List
                sx={{
                    flexGrow: 1,
                    transition: (theme: any) =>
                        theme.transitions.create(['all'], {
                            duration: theme.transitions.duration.enteringScreen,
                        }),
                    marginRight: !!match ? '400px' : 0,
                }}
                filters={filters}
                perPage={25}
                sort={{ field: 'date', order: 'DESC' }}
                actions={
                    <TopToolbar>
                        <FilterButton/>
                        <ExportButton maxResults={100000}/>
                    </TopToolbar>
                }
            >
                {isXSmall ? (
                    <HitchRequestsListMobile />
                ) : (
                    <HitchRequestsListDesktop
                        selectedRow={
                            !!match
                                ? parseInt((match as any).params.id, 10)
                                : undefined
                        }
                    />
                )}
            </List>
            <Drawer
                variant="persistent"
                open={!!match}
                anchor="right"
                onClose={handleClose}
                sx={{ zIndex: 100 }}
            >
                {/* To avoid any errors if the route does not match, we don't render at all the component in this case */}
                {!!match && (
                    <HitchRequestShow
                        id={(match as any).params.id}
                        onCancel={handleClose}
                    />
                )}
            </Drawer>
        </Box>
    );
};

export default HitchRequestsList;
